import { Autocomplete } from "stimulus-autocomplete"

export default class extends Autocomplete {
  connect() {
    this._disconnected = false
    this._abortController = new AbortController()
    super.connect()
  }

  disconnect() {
    this._disconnected = true
    this._abortController?.abort()
    super.disconnect()
  }

  doFetch = async (url) => {
    try {
      const response = await fetch(url, {
        ...this.optionsForFetch(),
        signal: this._abortController?.signal,
      })

      if (response.status === 401) {
        Turbo.visit("/accounts/sign_in", { action: "replace" })
        return ""
      }

      if (!response.ok) {
        throw new Error(`Server responded with status ${response.status}`)
      }

      return await response.text()
    } catch (error) {
      if (error.name === "AbortError" || error.name === "TypeError") {
        return ""
      }
      throw error
    }
  }
}
